import React from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import './Team.css';

interface TeamMember {
  id: number;
  name: string;
  role: string;
  image: string;
  description: string;
}

const Team: React.FC = () => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.2 });

  const teamMembers: TeamMember[] = [
    {
      id: 1,
      name: '陈燕南',
      role: '创始人 & 董事长',
      image: '/images/founder.webp',
      description: '北京师范大学发展与教育心理学专业毕业。近20年专注于艺术疗法在学校教育、家庭教育和专业培训领域的应用。累计完成3000+个案咨询。',
    },
    {
      id: 2,
      name: '李亦菲',
      role: '联合创始人',
      image: '/images/liyifei.webp',
      description: '华南师范大学应用心理学专业毕业。国家二级心理咨询师。高级绘画心理分析师。整合式艺术治疗师。',
    },
    {
      id: 3,
      name: '黎娟娟',
      role: '联合创始人',
      image: '/images/lijuanjuan.webp',
      description: '艺术心理教育联盟讲师。高级家庭教育指导师。游戏治疗师。正面管教学校讲师。',
    },
    {
      id: 4,
      name: '向佳璧',
      role: '项目总监',
      image: '/images/shangjiabi.webp',
      description: '艺术心理教育联盟联合创始人。国际教练联盟认证NLP教练。高级催眠治疗师。艺术治疗师。',
    },
  ];

  return (
    <section id="team" className="team">
      <div className="team-container" ref={ref}>
        <div className={`section-header ${isVisible ? 'visible' : ''}`}>
          <h2 className="section-title">团队介绍</h2>
          <p className="section-subtitle">
            经验丰富的核心团队，致力于艺术心理教育事业
          </p>
        </div>

        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div
              key={member.id}
              className={`team-card ${isVisible ? 'visible' : ''}`}
              style={{ transitionDelay: `${index * 0.1}s` }}
            >
              <div className="team-image-wrapper">
                <img src={member.image} alt={member.name} className="team-image" />
              </div>
              <div className="team-info">
                <h3 className="team-name">{member.name}</h3>
                <h4 className="team-role">{member.role}</h4>
                <p className="team-description">{member.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
